import { ISwivuProject } from "@/types/SwivuProject";
import {Model} from "@bryntum/schedulerpro";
import { User } from "./User";

export const INSIGHT_TYPES = {
  site_safety: {
    value: "site_safety",
    label: "Site Safety",
    category: "Site Safety"
  },
  workmanship: {
    value: "workmanship",
    label: "Workmanship",
    category: "Workmanship"
  },
  analyze: {
    value: "analyze",
    label: "Quinn’s Diagnostics",
    category: "Field Advisor"
  },
  execute: {
    value: "execute",
    label: "Hank’s Methods",
    category: "Field Advisor"
  },
  review: {
    value: "review",
    label: "Grace’s Evaluations",
    category: "Field Advisor"
  },
}

export const INSIGHT_LANGUAGE = {
  english: {
    label: "English",
    value: "en"
  },
  spanish: {
    label: "Spanish",
    value: "es"
  }
}

export class Insights extends Model {
  declare isPhantom: boolean;
  declare id: number | string;
  declare board: number;
  declare file: number;
  declare insightType: string;
  declare language: string;
  declare content: string;
  declare positiveFeedbackUsers: number[];
  declare negativeFeedbackUsers: number[];
  declare createdAt: Date;
  declare updatedAt: Date;
  declare creator: number;
  declare updater: number;

  declare project?: ISwivuProject;

  static get fields() {
    return [
      "id",
      { name: "board", type: "number" },
      { name: "file", type: "number" },
      { name: "insightType", dataSource: "insight_type", type: "string" },
      { name: "language", type: "string" },
      { name: "content", type: "string" },
      { name: "positiveFeedbackUsers", dataSource: "positive_feedback_users", defaultValue: [] },
      { name: "negativeFeedbackUsers", dataSource: "negative_feedback_users", defaultValue: [] },
      { name: "createdAt", dataSource: "created_at", type: "date" },
      { name: "updatedAt", dataSource: "updated_at", type: "date" },
      { name: "creator", type: "number" },
      { name: "updater", type: "number" },
    ];
  }

  get negativeFeedbackUserRecords(): User[] {
    return this.get("negativeFeedbackUsers")?.map((userId: number) => this.project?.boardUsersStore.getById(userId));
  }

  get positiveFeedbackUserRecords(): User[] {
    return this.get("positiveFeedbackUsers")?.map((userId: number) => this.project?.boardUsersStore.getById(userId));
  }
}